import script from "./MenuScene.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuScene.vue?vue&type=script&setup=true&lang=js"

import "./MenuScene.vue?vue&type=style&index=0&id=336443e2&lang=scss&scoped=true"
import "./MenuScene.vue?vue&type=style&index=1&id=336443e2&lang=css"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-336443e2"]])

export default __exports__